import script from "./BaseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=abd10cba&lang=css&scoped=true"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abd10cba"]])

export default __exports__